import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9bcb56a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row",
  style: {"border-radius":"25px","top":"50px"}
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body-custom" }
const _hoisted_4 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_5 = {
  key: 0,
  class: "badge__status--completed"
}
const _hoisted_6 = {
  key: 1,
  class: "badge__status--cancelled"
}
const _hoisted_7 = {
  key: 0,
  class: "row",
  style: {"border-radius":"25px","margin-top":"20px"}
}
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body-custom" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary__title" }, "Summary", -1))
const _hoisted_11 = { class: "summary__content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Order report", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = { class: "summary__content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Completed", -1))
const _hoisted_16 = { class: "summary__content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Canceled", -1))
const _hoisted_18 = { class: "summary__title mt-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.originalConfig != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "btn btn-info",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportReportToExcel()))
                  }, " Download excel ")
                ]))
              : _createCommentVNode("", true),
            (_ctx.originalConfig != null)
              ? (_openBlock(), _createBlock(_component_Datatable, {
                  key: 1,
                  "table-header": _ctx.tableHeader,
                  "table-data": _ctx.reportList,
                  "rows-per-page": 5,
                  "enable-items-per-page-dropdown": true
                }, {
                  "cell-order_code": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.order_code), 1)
                  ]),
                  "cell-order_type": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.order_type == 1 ? "Food delivery" : "Messenger"), 1)
                  ]),
                  "cell-order_time_start": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.order_time_start), 1)
                  ]),
                  "cell-order_store": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.order_store), 1)
                  ]),
                  "cell-order_customer_full_name": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.order_customer_full_name), 1)
                  ]),
                  "cell-order_rider_full_name": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.order_rider_full_name), 1)
                  ]),
                  "cell-order_status": _withCtx(({ row: item }) => [
                    (item.order_status == 'completed')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.order_status.toUpperCase()), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.order_status.toUpperCase()), 1))
                  ]),
                  "cell-order_net_price": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.order_net_price), 1)
                  ]),
                  _: 1
                }, 8, ["table-header", "table-data"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.originalConfig != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", null, "Date : " + _toDisplayString(_ctx.moment(_ctx.originalConfig.startDate).format("YYYY/MM/DD")) + " - " + _toDisplayString(_ctx.moment(_ctx.originalConfig.endDate).format("YYYY/MM/DD")), 1)
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", null, _toDisplayString(_ctx.countOrderFoodComplete + _ctx.countOrderMessengerComplete), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", null, _toDisplayString(_ctx.countOrderFoodCancel + _ctx.countMessengerFoodCancel), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("span", null, _toDisplayString(_ctx.reportList.length), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}